import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'pageTitle',
    defaultMessage: 'Support Tools | {siteName}',
    description: 'Title tag',
  },
});
export default messages;
